module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "show": _vm.show == _vm.id
    },
    on: {
      "open": _vm.reset
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Ny egenskap")]), _c('form', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('v-textfield', {
    attrs: {
      "id": "label",
      "name": "PropertyLabel",
      "label": "Etikett",
      "validate": "required|max: 16"
    },
    on: {
      "errors": function($event) {
        _vm.showErrors($event)
      }
    },
    model: {
      value: (_vm.p.label),
      callback: function($$v) {
        _vm.$set(_vm.p, "label", $$v)
      },
      expression: "p.label"
    }
  }), _c('v-textfield', {
    attrs: {
      "id": "name",
      "name": "PropertyName",
      "label": "Namn",
      "validate": "required"
    },
    on: {
      "errors": function($event) {
        _vm.showErrors($event)
      }
    },
    model: {
      value: (_vm.p.name),
      callback: function($$v) {
        _vm.$set(_vm.p, "name", $$v)
      },
      expression: "p.name"
    }
  }), _c('v-textfield', {
    attrs: {
      "id": "description",
      "name": "description",
      "label": "Beskrivning"
    },
    model: {
      value: (_vm.p.description),
      callback: function($$v) {
        _vm.$set(_vm.p, "description", $$v)
      },
      expression: "p.description"
    }
  }), _c('v-checkbox', {
    attrs: {
      "id": "is_active",
      "label": "Är aktiv"
    },
    on: {
      "change": function($event) {
        _vm.set('is_active', arguments[0])
      }
    },
    model: {
      value: (_vm.p.is_active),
      callback: function($$v) {
        _vm.$set(_vm.p, "is_active", $$v)
      },
      expression: "p.is_active"
    }
  }), _c('v-selectfield', {
    attrs: {
      "id": "type",
      "label": "Datatyp",
      "options": _vm.types
    },
    model: {
      value: (_vm.p.type),
      callback: function($$v) {
        _vm.$set(_vm.p, "type", $$v)
      },
      expression: "p.type"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_error),
      expression: "show_error"
    }]
  }, [_c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(" " + _vm._s(error))])
  }))])], 1), _c('span', {
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("OK  ")]), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52ed59a2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dialog/PropertyAdd.vue
// module id = 520
// module chunks = 1